import axiosInstance from 'api/axiosInstance';
export interface CANtrackCommentRaw {
	Id: string;
	Description: string;
	CommentListGroupId: string;
	CustomerId: string;
	CustomerName: string;
	CaseId: string;
	CaseTitle: string;
	GroupId: string;
	GroupTitle: string;
	ProjectId: string;
	ProjectTitle: string;
	DeliverableId: string;
	DeliverableTitle: string;
	ActivityId: string;
	ActivityTitle: string;
	TaskId: string;
	TaskTitle: string;
	EntryDate: string;
	TimeRegular: string;
	TimeOver: string;
	Billable: string;
	ConsultantId?: string;
	ConsultantName?: string;
	ConsultantContactId?: string;
}

async function getComments(
	date: Date,
	employeeId: string,
): Promise<CANtrackCommentRaw[]> {
	const payload = {
		Date: new Date(date.setHours(0, 0, 0, 0)),
		ConsultantId: employeeId,
		Take: 5000,
	};
	const data = await axiosInstance.get(
		`/api/cantrackv3/ReadComments?payload=${JSON.stringify(payload)}`,
	);
	if (!data || !data.data.Data)
		throw new Error('Failed to fetch timesheet entries');
	return data.data.Data;
}

export default getComments;
